var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog',{attrs:{"id":"dialog"}},[_c('form',{attrs:{"method":"dialog"}},[_c('p',[_vm._v("Hi, I'm a dialog.")]),_c('button',[_vm._v("OK")])])]),_c('button',{attrs:{"onclick":"dialog.showModal()"}},[_vm._v("Open Dialog")]),_c('input',{attrs:{"type":"datetime-local"}})])
}]

export { render, staticRenderFns }